import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { links } from "utilities/links";
import { TransactionForm } from "./TransactionForm";

export function AddTransaction() {
  const { message } = useMessage();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "transactions" }),
      path: links.transactionsList,
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "addTransaction" })}
        clearLink={links.transactionsList}
        breadcrumbs={breadcrumbs}
      />
      <TransactionForm />
    </>
  );
}
